/* eslint-disable no-unused-vars */
// MAP API KEY
import moment from "moment";
import { Images } from "./images";

export const GOOGLE_MAP_API_KEY = "AIzaSyD0p1kvR8ZcBZHNqQOJqCZJ0VsIS5Itc3Q";

// API ENDPOINT
export const API_URL_TOKEN = "auth/login";
export const API_REFRESH_COOKIE_PATH = "api/refresh-token";
export const API_USERNAME = "api";
export const API_PASSWORD = "jYsMz0XDlUr8Wedz";

// export const API_ENDPOINT = "http://dev.kidoshop.vn:8080/";
// export const API_ENDPOINT = "https://sb.kidoshop.vn/";
export const API_ENDPOINT = "https://api.kidoshop.vn/";

export const HEIGHT_HEADER = 60;
export const HEIGHT_FOOTER = 50;
export const HEIGHT_HEADER_MENU_COMPANY = 54;
export const HEIGHT_HEADER_HORIZONTAL_MENU = 49;
export const HEIGHT_FOOTER_ORDER = 64;

export const number_format = (number, decimals, dec_point, thousands_sep) => {
	var n = !isFinite(+number) ? 0 : +number,
		prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
		sep = typeof thousands_sep === "undefined" ? "." : thousands_sep,
		dec = typeof dec_point === "undefined" ? "." : dec_point,
		toFixedFix = function (n2, prec2) {
			var k = Math.pow(10, prec2);
			return Math.round(n2 * k) / k;
		},
		s = (prec ? toFixedFix(n, prec) : Math.round(n)).toString().split(".");
	if (s[0].length > 3) {
		s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
	}
	if ((s[1] || "").length < prec) {
		s[1] = s[1] || "";
		s[1] += new Array(prec - s[1].length + 1).join("0");
	}
	return s.join(dec);
};

export const objectToQueryString = (obj, prefix) => {
	var str = [],
		p;
	for (p in obj) {
		if (obj[p]) {
			var k = prefix ? prefix + "[" + p + "]" : p,
				v = obj[p];
			str.push(encodeURIComponent(k) + "=" + encodeURIComponent(v));
		}
	}
	return str.join("&");
};

export const formatCash = (x, decimals) => {
	if (!x) {
		return "0";
	}
	return number_format(x, decimals ?? ".");
};

// loai khuyen mai
export const TYPE_CAMPAIGN = {
	PRODUCT_GIFT: {
		name: "Khuyến mãi tặng hàng",
		color: "#FF9960",
		type: "PRODUCT_GIFT",
		backgroundColor: "#FF9960"
	},
	DISCOUNT_BILL: {
		name: "Giảm trực tiếp vào đơn hàng",
		color: "#2F80ED",
		type: "DISCOUNT_BILL",
		backgroundColor: "#2F80ED"
	},
	MONEY_GIFT: {
		color: "#56C080",
		type: "MONEY_GIFT",
		name: "Tặng tiền mua hàng",
		backgroundColor: "#56C080"
	},
	OTHER: {
		color: "#FDC32D",
		type: "OTHER",
		name: "Combo nhiều khuyến mãi",
		backgroundColor: "#FDC32D"
	}
};

export const TYPE_LOYALTY = {
	GIFT: { type: "GIFT", bacground: "#FFBC57", name: "Tích luỹ đổi quà" },
	ACCUMULATE_POINT: {
		type: "ACCUMULATE_POINT",
		bacground: "#F89C5A",
		name: "Tích luỹ đổi điểm"
	}
};

export const STATUS_ACCUMULATE = {
	UNKNOW: {
		text: "Chưa xác định",
		color: "#F5222D",
		backgroundColor: "#FFF1F0",
		description: "Chưa xác định"
	},
	NOT_START: {
		text: "Chưa diễn ra",
		color: "#F5222D",
		backgroundColor: "#FFF1F0",
		description: "Chương trình chưa diễn ra"
	},
	PROCESSING_REGISTER: {
		text: "Đang diễn ra ĐK",
		color: "#52C41A",
		backgroundColor: "#F6FFED",
		description: "Đang trong thời gian đăng ký"
	},
	PROCESSING_APPLY: {
		text: "Đang mua & TL",
		color: "#52C41A",
		backgroundColor: "#F6FFED",
		description: "Đang trong thời gian mua & TL"
	},
	PROCESSING_REWARD: {
		text: "Đang trả thưởng",
		color: "#52C41A",
		backgroundColor: "#F6FFED",
		description: "Đang trong thời gian trả thưởng"
	},
	ENDED: {
		text: "Đã kết thúc",
		color: "#F5222D",
		backgroundColor: "#FFF1F0",
		description: "Chương trình đã kết thúc"
	}
};

export const STATUS_ORDER = {
	NEW: {
		statusName: "Đơn mới",
		color: "#EC1C24"
	},
	WAITING_CONFIRM: {
		statusName: "Chờ xác nhận",
		color: undefined
	},
	CONFIRMED: {
		statusName: "Đã xác nhận",
		color: undefined
	},
	PACKED: {
		statusName: "Đã đóng gói",
		color: undefined
	},
	SHIPPING: {
		statusName: "Đang giao",
		color: "#F7C102"
	},
	FINISHED: {
		statusName: "Hoàn thành",
		color: "#219653"
	},
	CANCELED: {
		statusName: "Đã huỷ",
		color: "#EC1C24"
	},
	RETURNED: {
		statusName: "Đã huỷ",
		color: undefined
	},
	AUTO_RETURNED: {
		statusName: "Đã huỷ",
		color: "#EC1C24"
	},
	CANCELED_RENEW: {
		statusName: "Đã huỷ",
		color: undefined
	},
	CANT_SHIP: {
		statusName: "Giao không thành công",
		color: undefined
	},
	OUT_OF_RANG_SHOP: {
		statusName: "Đơn hàng ngoài shop",
		color: undefined
	},
	EXPORTED: {
		statusName: "Đã xuất kho",
		color: "#F7C102"
	},
	SHIP_FAILED: {
		statusName: "Giao thất bại",
		color: undefined
	},
	ON_SHIPPING: {
		statusName: "Đang giao",
		color: "#F7C102"
	},
	WAITING_APPROVE: {
		statusName: "Đơn cần xác nhận",
		color: "#F7C102"
	},
	APPROVED: {
		statusName: "Đã duyệt",
		color: "#52C41A"
	},
	COMPANY_APPROVED: {
		statusName: "Công ty đã duyệt",
		color: "#52C41A"
	},
	COMPANY_REJECTED: {
		statusName: "Công ty từ chối",
		color: "#EC1C24"
	}
};

export const STATUS_MERCHANDISING_ORDER = {
	NEW: {
		statusName: "Đơn mới",
		color: "#EC1C24"
	},
	WAITING_CONFIRM: {
		statusName: "Chờ xác nhận",
		color: undefined
	},
	CONFIRMED: {
		statusName: "Đã xác nhận",
		color: undefined
	},
	PACKED: {
		statusName: "Đã đóng gói",
		color: undefined
	},
	SHIPPING: {
		statusName: "Đang giao",
		color: "#F7C102"
	},
	FINISHED: {
		statusName: "Đã trả thưởng",
		color: "#219653"
	},
	CANCELED: {
		statusName: "Đã huỷ",
		color: "#EC1C24"
	},
	RETURNED: {
		statusName: "Đã huỷ",
		color: undefined
	},
	AUTO_RETURNED: {
		statusName: "Đã huỷ",
		color: "#EC1C24"
	},
	CANCELED_RENEW: {
		statusName: "Đã huỷ",
		color: undefined
	},
	CANT_SHIP: {
		statusName: "Giao không thành công",
		color: undefined
	},
	OUT_OF_RANG_SHOP: {
		statusName: "Đơn hàng ngoài shop",
		color: undefined
	},
	EXPORTED: {
		statusName: "Đã xuất kho",
		color: "#F7C102"
	},
	SHIP_FAILED: {
		statusName: "Giao thất bại",
		color: undefined
	},
	ON_SHIPPING: {
		statusName: "Đang giao",
		color: "#F7C102"
	},
	WAITING_APPROVE: {
		statusName: "Đơn cần xác nhận",
		color: "#F7C102"
	},
	APPROVED: {
		statusName: "Đã duyệt",
		color: "#52C41A"
	},
	COMPANY_APPROVED: {
		statusName: "Công ty đã duyệt",
		color: "#52C41A"
	},
	COMPANY_REJECTED: {
		statusName: "Công ty từ chối",
		color: "#EC1C24"
	}
};

export const TYPE_ORDER = {
	SALE: {
		text: "Đơn bán"
	},
	EXCHANGE: {
		text: "Đơn thu hồi đổi trả"
	},
	DISPLAY_EVENT: {
		text: "Đơn trưng bày"
	},
	MERCHANDISING: {
		text: "Đơn trả trưng bày"
	},
	EVICTION: {
		text: "Thu hồi không đổi trả"
	},
	LOYALTY: {
		text: "Đơn trả tích luỹ"
	}
};

export const formatDate = time => {
	return moment(time, "DD/MM/YYYY hh:mm:ss").format("DD/MM/YYYY");
};

export function getParamUrl(url) {
	let params = {};
	url.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
		params[key] = value;
	});
	return params;
}

export const totalQuantity = arr => {
	if (arr?.length) {
		const sum = arr?.reduce(
			(previousValue, currentValue) => previousValue + currentValue
		);
		return sum;
	} else {
		return 0;
	}
};

export const checkMobile = () => {
	const ua = navigator.userAgent;
	if (/(playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
		return true;
	} else if (/(tablet|ipad)|(android(?!.*mobi))/i.test(ua)) {
		return false;
	} else if (
		/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
			ua
		)
	) {
		return true;
	}
	return false;
};

export const MENU_USER = {
	CHANGE_PASSWORD: "/change_password",
	SIGNATURE: "/signature",
	INFORMATION_STORE: "/information_store",
	DELETE_ACCOUNT: "/delete_account",
	FEED_BACK: "/feed_back",
	CHAT_WITH_SALESMAN: "/chat_with_salesman"
};

export const NOTIFICATION_TYPE = {
	CHANGE_ORDER_STATUS: {
		name: "Đơn hàng",
		type: "CHANGE_ORDER_STATUS",
		image: Images.icOrderNoti
	},
	CRM_ORDER: {
		name: "Đơn hàng CRM",
		type: "CRM_ORDER",
		image: Images.icOrderNoti
	},
	PROMOTION: {
		name: "Khuyến mãi",
		type: "PROMOTION",
		image: Images.icPromotionNoti
	},
	MERCHANDISING: {
		name: "Trưng bày",
		type: "MERCHANDISING",
		image: Images.icMerchandisingNoti
	},
	LOYALTY: {
		name: "Tích luỹ",
		type: "LOYALTY",
		image: Images.icLoyaltyNoti
	},
	NEW: {
		name: "Tin tức",
		type: "NEW",
		image: Images.icNewsNoti
	},
	UPDATE_SYSTEM: {
		name: "Cập nhật hệ thống",
		type: "UPDATE_SYSTEM",
		image: Images.icSettingNoti
	},
	FORCE_UPDATE: {
		name: "Cập nhật ứng dụng",
		type: "FORCE_UPDATE",
		image: Images.icSettingNoti
	}
};

export async function checkImageExists(imageUrl) {
	try {
		const response = await fetch(imageUrl, {
			method: "HEAD",
			mode: "no-cors"
		});
		if (response.status !== 404) {
			return true;
		}
		return false;
	} catch (error) {
		return false;
	}
}

export const VERIFY_DEVICE_SHOW_TYPE = [
	"WAITING_APPROVE",
	"REJECTED",
	"LOCKED",
	"NEW_APPROVED"
];

export const REDIRECT_CHANGE_PASSWORD = [
	"ABOUT_TO_EXPIRE",
	"DEFAULT",
	"FORCE_UPDATE",
	"EXPIRED"
];

export const SKIP_CHANGE_PASSWORD = ["ABOUT_TO_EXPIRE"];

export const getIsApp = () => {
	return localStorage.getItem("isApp") === "true" ? true : false;
};
